<template>
    <tecno-map
        v-if="mapLoaded"
        ref="map"
        :loading="dataLoading"
        :options="mapOptions"
        :section="section"
        @ready="mapAfterLoad()"
    >
        <template v-slot:extra>
            <div v-show="mapLoaded" class="tecnomap-container">
                <div class="tecnomap-left-sidebar">
                    <div v-if="mapDrawable" class="draw-tools">
                        <button @click.stop="enableDraw('draw')" class="tecnomap-controls-element btn btn-google first" :class="{'active': mapDrawMode == 'draw'}">
                            <img :src="'/img/icons/' + $root.network + '/draw-map-list.svg'" class="btn-control-map defualt" />
                            <img :src="'/img/icons/' + $root.network + '/draw_map_over.svg'" class="btn-control-map hover" />
                            <img :src="'/img/icons/' + $root.network + '/draw_map_active.svg'" class="btn-control-map selected" />
                            <span>{{ lang.labels.draw_polygon_list }}</span>
                        </button>

                        <button @click.stop="enableDraw('edit')" class="tecnomap-controls-element btn btn-google" :class="{'active': mapDrawMode == 'edit'}" :disabled="!hasUserPolygons">
                            <img :src="'/img/icons/' + $root.network + '/move_map-list.svg'" class="btn-control-map defualt" />
                            <img :src="'/img/icons/' + $root.network + '/move_map_over.svg'" class="btn-control-map hover" />
                            <img :src="'/img/icons/' + $root.network + '/move_map_active.svg'" class="btn-control-map selected" />
                            <span>{{ lang.labels.move_polygon_list }}</span>
                        </button>

                        <button @click.stop="enableDraw('delete')" class="tecnomap-controls-element btn btn-google" :class="{'active': mapDrawMode == 'delete'}" :disabled="!hasUserPolygons">
                            <img :src="'/img/icons/' + $root.network + '/delete_map-list.svg'" class="btn-control-map defualt" />
                            <img :src="'/img/icons/' + $root.network + '/delete_map_over.svg'" class="btn-control-map hover" />
                            <img :src="'/img/icons/' + $root.network + '/delete_map_active.svg'" class="btn-control-map selected" />
                            <span>{{ lang.labels.delete_polygon_list }}</span>
                        </button>

                        <button @click.stop="locate()" class="tecnomap-controls-element btn btn-google" :class="{'active': isGeolocating}" >
                            <img :src="'/img/icons/' + $root.network + '/geo_map-list.svg'" class="btn-control-map defualt" />
                            <img :src="'/img/icons/' + $root.network + '/geo_map_over.svg'" class="btn-control-map hover" />
                            <img :src="'/img/icons/' + $root.network + '/geo_map_active.svg'" class="btn-control-map selected" />
                            <span class="geoloc">{{ lang.labels.geoloc }}</span>
                        </button>
                    </div>

                    <div class="zoom-btn">
                        <button @click.stop="zoomIn()" class="tecnomap-controls-element btn zoom-in" :disabled="mapLimits.zoomIn">+</button>
                        <button @click.stop="zoomOut()" class="tecnomap-controls-element btn zoom-out" :disabled="mapLimits.zoomOut">–</button>
                    </div>
                </div>

                <div
                    v-if="section == 'estate' && allEstatesEnabled"
                    class="all-estates-cont"
                >
                    <button @click.stop="removeBounds()" class="tecnomap-controls-element btn btn-google all-estates-btn">
                        {{ lang.labels.all_estates }}
                    </button>
                </div>

                <div class="tecnomap-interaction form-check" v-if="config_map.update_list && config_map.update_list_button && mapFeatures.length > 0">
                    <input
                        v-model="mapInteraction"
                        type="checkbox"
                        id="map-interaction"
                        class="form-check-input"
                    >
                    <label for="map-interaction">{{ lang.labels.reload }}</label>
                </div>
            </div>
        </template>
    </tecno-map>
</template>
<style lang="sass">
.col-maps
    .mapboxgl-map
        height: 1000px

.mapboxgl-popup-content
    .estate-card
        margin-bottom: 0
        min-height: 325px
        min-width: 348px
</style>
<script>
import TecnoMap from '../maps/Map'
import MapCarousel from './MapCarousel'
import { updateUriParam } from '../../helpers/urls'
import { differenceBetweenObjects } from '../../helpers/objects'
import { default as helpers } from '../maps/mixins/Helpers'
import { default as drawer } from '../maps/mixins/Drawer'

import _ from 'lodash'

export default {
    mixins: [
        helpers,
        drawer,
    ],

    data() {
        return {
            isGeolocating: false,
            mapOptions: {
                minZoom: 9,
                maxZoom: 18,
                currentZoom: 9,
                style: '/core/v1/' + this.$root.country_full_name + '/style.json',

                mapCenter: {},

                features: {
                    uriCoords: false,
                    scrollZoom: true,
                    dragRotate: false,
                    touchZoomRotate: true
                },

                modules: {
                    navigationControl: {
                        uiPosition: 'top-left',
                        zoom: {
                            listen: true
                        },
                        geolocate: {
                            listen: true
                        }
                    },

                    drawer: {
                        maxRadiusKm: 2,
                        modes: ['circle', 'hand'],
                        maxPolygons: 70,
                        insideColor: this.config_map.inside_color,
                        outsideColor: this.config_map.outside_color,
                        fillColor: '#089642',
                        textColor: '#fff',
                        labelColor: '#222',
                        labelColorDisabled: '#222',
                        fillColorDisabled: '#888',
                        fillOpacity: this.config_map.fill_opacity,
                        fillOpacityDisabled: 0.12,
                        clusterRadius: this.$root.country == 'es' ? 25 : 35,
                        listen: true,
                        legacyMode: false
                    },

                    poi: {
                        country: this.$root.country_full_name,
                        endpoint: window.tecnomapsEndpoint + '/v2/services/poi',
                        fixed: ['public_transport', 'ev_charging']
                    }
                }
            },
            mapLoaded: false,
            mapDrawerLoaded: false,
            forceMapViewUpdate: false,
            polygonsLoaded: false,
            estatesLoaded: false,
            dataLoading: false,
            mapSearch: {},
            previousMapSearch: null,
            cancelTokens: {
                requestPolygons: null,
                requestEstates: null
            },
            polygonsIdentifiers: {
                districts: []
            },
            mapInteraction: false,
            allEstatesEnabled: false
        }
    },

    props: {
        config_map: {
            type: Object,
            required: true,
        },

        mapDrawable: {
            type: Boolean,
            default: function() {
                return this.config_map.map_drawable
            },
        },

        search: {
            type: Object,
            required: true,
        },

        section: {
            type: String,
            required: true,
        },

        map_center: {
            type: [Array, Boolean],
            required: false
        }
    },

    computed: {
        lang() {
            return this.$root.lang.tecnomap
        },

        hasUserPolygons() {
            return this.mapFeatures.filter(feature => (feature.properties.drawable || feature.properties.drawable == undefined)).length > 0
        }
    },

    watch: {
        hasUserPolygons(value, oldValue) {
            if(oldValue == true && value == false)
            {
                if(['delete', 'edit'].includes(this.mapDrawMode))
                {
                    this.enableDraw(this.mapDrawMode)
                }
            }
        },

        // mapInteraction(value, oldValue) {
        //     if (this.config_map.update_list_button) {
        //         $cookies.set('map_interaction', value ? 1 : 0, '1y', '', '', true)
        //     }

        //     if((value == true && oldValue == false) || (value == false && oldValue == true))
        //     {
        //         this.requestEstates()
        //         window.events.$emit('list.update.bounds', this.mapSearch['view'])
        //     }
        // }
    },

    methods: {
        searchCriteria() {
            let criteria = {
                ...this.search,
                ...this.mapSearch,
                'section': this.section,
            }

            if(criteria['quarters'] != undefined && criteria['quarters'] != null)
            {
                if(typeof criteria['quarters'] === 'string')
                {
                    if(criteria['quarters'] == '')
                        criteria['quarters'] = []
                    else
                        criteria['quarters'] = criteria['quarters'].split('|')
                }
                else if(Array.isArray(criteria['quarters']))
                    criteria['quarters'] = criteria['quarters']
                else if(criteria['quarters'] != undefined)
                    criteria['quarters'] = [ criteria['quarters'] ]
            }

            if(criteria['districts'] != undefined && criteria['districts'] != null)
            {
                if(typeof criteria['districts'] === 'string')
                {
                    if(criteria['districts'] == '')
                        criteria['districts'] = []
                    else
                        criteria['districts'] = criteria['districts'].split('|')
                }
                else if(Array.isArray(criteria['districts']))
                    criteria['districts'] = criteria['districts']
                else if(criteria['districts'] != undefined)
                    criteria['districts'] = [ criteria['districts'] ]
            }
            else if(criteria['district'] != undefined && criteria['district'] != null)
            {
                criteria['districts'] = [ criteria['district'] ]
                delete criteria['district']
            }

            if(this.previousMapSearch != null)
            {
                let differences = differenceBetweenObjects(_.cloneDeep(this.previousMapSearch), _.cloneDeep(criteria))
                let intersection = _.intersection(Object.keys(differences), ['city', 'province'])

                if(intersection.length > 0)
                {
                    if(intersection.length == 1 && intersection.includes('province'))
                    {
                        if(differences.province.to != undefined)
                        {
                            this.forceMapViewUpdate = true
                        }
                    }
                    else
                    {
                        this.forceMapViewUpdate = true
                    }
                }
            }

            this.previousMapSearch = _.cloneDeep(criteria)

            if (criteria.polygon_id || criteria.region || criteria.province || criteria.city || criteria.districts || criteria.district) {
                if (!this.config_map.update_list) {
                    criteria.view = null
                    criteria.zoom = null
                }
                this.allEstatesEnabled = true
            } else {
                this.allEstatesEnabled = false
            }

            return criteria
        },

        hasPolygons() {
            return (this.searchCriteria()['polygon_id'] != undefined
                || (this.searchCriteria()['region'] != undefined && this.config_map.geo.includes('region'))
                || (this.searchCriteria()['province'] != undefined && this.config_map.geo.includes('province'))
                || (this.searchCriteria()['city'] != undefined && this.config_map.geo.includes('city'))
                || (this.searchCriteria()['cities'] != undefined && this.config_map.geo.includes('cities'))
                || (this.searchCriteria()['districts'] != undefined && this.config_map.geo.includes('district'))
                || (this.searchCriteria()['district'] != undefined && this.config_map.geo.includes('district'))
            )
        },

        mapAfterLoad()
        {
            if (this.$refs.map.id) {
                if(this.search['view'] != undefined)
                {
                    this.markers_loaded = true

                    let bbox = this.search['view'].split(',')
                    this.dispatchEvent('tecnomap.interactions.fitBounds', {
                        bbox: [
                            [bbox[1], bbox[0]],
                            [bbox[3], bbox[2]]
                        ]
                    })
                }

                this.requestPolygons()
                this.requestEstates()
            }
        },

        requestPolygons()
        {
            if(this.hasPolygons() && !this.config_map.no_polygon)
            {
                if(this.cancelTokens.requestPolygons != null)
                    this.cancelTokens.requestPolygons.cancel()

                this.cancelTokens.requestPolygons = axios.CancelToken.source()

                axios.get('/api/estates/get-polygons', {
                    cancelToken: this.cancelTokens.requestPolygons.token,
                    params: this.searchCriteria()
                })
                .then(response => {
                    if(response != undefined)
                    {
                        this.polygonsIdentifiers.districts = _.map(response.data.features.filter((value) => value.properties.type == 'district'), 'properties.id')

                        if (this.$refs.map.id) {
                            this.dispatchEvent('tecnomap.drawer.setPolygons', {
                                featureCollection: response.data,
                                editable: true,
                                bounds: ((this.polygonsLoaded == false && this.searchCriteria()['view'] == undefined) || this.forceMapViewUpdate) ? true : false,
                                limited: false,
                                ignoreDisabled: this.$root.country == 'hu' ? true : false
                            }, 'mapDrawerLoaded')
                        }
                        this.polygonsLoaded = true
                        this.forceMapViewUpdate = false
                        window.events.$emit('bottommenu.map.polygons', response.data)
                    }
                })
                .catch((error) => {
                    this.polygonsLoaded = false
                    if((typeof error !== 'undefined') && (error.status == 404))
                    {
                        flash(this.lang.flash.expired, 'error')
                        this.removeBounds()
                    }
                    else
                    {
                        flash(this.lang.flash.error, 'error')
                    }
                })
            }
        },

        requestEstates()
        {
            if(this.hasPolygons() || this.searchCriteria()['view'] != undefined)
            {
                if(this.cancelTokens.requestEstates != null)
                    this.cancelTokens.requestEstates.cancel()

                this.cancelTokens.requestEstates = axios.CancelToken.source()

                this.dataLoading = true
                axios.get('/api/estates/search-map-list', {
                    cancelToken: this.cancelTokens.requestEstates.token,
                    params: this.searchCriteria()
                })
                .then((response) => {
                    if(response != undefined)
                    {
                        window.events.$emit('list.heading.count', response.data.total)
                        if (this.$refs.map.id) {
                            this.dispatchEvent('tecnomap.drawer.setMarkers', {
                                featureCollection: response.data.collection,
                                bounds: (this.config_map.no_polygon && !this.searchCriteria().view) ? true : false
                            }, 'mapDrawerLoaded')
                        }

                        this.estatesLoaded = true
                    }
                })
                .catch((error) => {
                    this.estatesLoaded = false
                    if (this.$refs.map.id) {
                        this.dispatchEvent('tecnomap.drawer.setMarkers', { featureCollection: {
                            type: 'FeatureCollection',
                            features: []
                        }}, 'mapDrawerLoaded')
                    }
                })
                .then(() => {
                    this.dataLoading = false
                })
            }
            else
            {
                this.removeBounds()
            }
        },

        mapMoved(event)
        {
            if(this.checkMapScope(event))
            {
                if(this.mapTouchedByUser)
                {
                    let newUrl = updateUriParam(null, 'view', [
                        event.detail.bbox._ne.lat, event.detail.bbox._ne.lng,
                        event.detail.bbox._sw.lat, event.detail.bbox._sw.lng
                    ].join(','))
                    newUrl = updateUriParam(newUrl, 'zoom', event.detail.zoom)
                    window.history.pushState({path:newUrl},'',newUrl)

                    this.mapSearch['zoom'] = event.detail.zoom
                    this.mapSearch['view'] = [
                        event.detail.bbox._ne.lat,  event.detail.bbox._ne.lng,
                        event.detail.bbox._sw.lat,  event.detail.bbox._sw.lng
                    ].join(',')

                    if(this.mapInteraction)
                    {
                        this.requestEstates()
                        window.events.$emit('list.update.bounds', this.mapSearch['view'])
                    }

                    this.mapTouchedByUser = false
                }
            }
        },

        showEstatePopup(event)
        {
            if(this.checkMapScope(event))
            {
                this.dataLoading = true
                axios.get('/api/estates/search-by-ids', {
                    params: {
                        ids:  event.detail.features.map((feature) => feature.id),
                        section: this.section
                    }
                })
                .then((response) => {
                    this.dispatchEvent('tecnomap.drawer.attachMarkerPopup', {
                        coordinates: event.detail.coordinates,
                        html: '<div id="vue-map-list-estate-card"></div>'
                    })

                    var EstateCard = Vue.extend(MapCarousel)

                    new EstateCard({
                        propsData: {
                            estates: response.data,
                            extLang: this.$root.lang.estate_card,
                            showActions: false,
                        },
                    }).$mount('#vue-map-list-estate-card')

                    this.dispatchEvent('tecnomap.drawer.refreshMarkerPopup', {})
                })
                .catch((error) => {
                    console.log(error)
                })
                .then(() => {
                    this.dataLoading = false
                })
            }
        },

        removeBounds()
        {
            this.mapFeatures = []
            this.mapShape = []
            this.mapCenter = []
            this.mapArea = 0
            this.mapInteraction = true

            this.search.cardinal =
            this.search.city =
            this.search.districts =
            this.search.province =
            this.search.quarters =
            this.search.region =
            this.search.polygon =
            this.search.polygon_id =
            this.search.placeholder = null
            
            if(this.mapDrawMode != null)
                this.enableDraw(this.mapDrawMode)

            this.dispatchEvent('tecnomap.drawer.reset', {}, 'mapDrawerLoaded')
        },

        polygonsHaveBeenRemoved(event)
        {
            if(this.checkMapScope(event))
            {
                this.mapSearch['view'] = [
                    event.detail.bbox._ne.lat, event.detail.bbox._ne.lng,
                    event.detail.bbox._sw.lat, event.detail.bbox._sw.lng
                ].join(',')
                this.mapSearch['polygon_id'] = null
                this.mapSearch['region'] = null
                this.mapSearch['province'] = null
                this.mapSearch['city'] = null
                this.mapSearch['cities'] = null
                this.mapSearch['district'] = null
                this.mapSearch['districts'] = null
                window.events.$emit('list.update.polygon_id', null)
                window.events.$emit('list.update.filters', this.mapSearch)
            }
        },

        startGeolocating(event)
        {
            if(event.detail.container == this.$refs.map.id)
            {
                this.isGeolocating = true
            }
        },

        endGeolocating(event)
        {
            if(event.detail.container == this.$refs.map.id)
            {
                this.isGeolocating = false
            }
        },

        locate()
        {
            window.dispatchEvent(new CustomEvent('tecnomap.navigationControl.geolocate', { detail: { id: this.$refs.map.id }}))
        },

        // setAllEstatesEnabled() {
        //     let criteria = this.searchCriteria()
            
        //     this.allEstatesEnabled = (this.mapDrawable && this.mapFeatures.length > 0) || this.config_map.no_polygon
        // },

        setMapInteraction() {
            if (!this.search.cardinal && !this.search.city && !this.search.districts && !this.search.province && !this.search.quarters && !this.search.region) {
                this.mapInteraction = true
            } else {
                this.mapInteraction = (this.config_map.update_list && $cookies.get('map_interaction')) ? parseInt($cookies.get('map_interaction')) : (this.config_map.update_list ?? 1)
            }
        }
    },

    created() {
        if(this.map_center != undefined && this.map_center != false)
            this.mapOptions.mapCenter.coords = this.map_center
        else
            this.mapOptions.mapCenter.coords = [0,0]

        if(this.search.zoom != undefined)
            this.mapOptions.currentZoom = parseFloat(this.search.zoom)

        if(this.$root.network == 'tecnorete')
        {
            this.mapOptions.modules.drawer = {
                ...this.mapOptions.modules.drawer,
                insideColor: '#003596',
                outsideColor: '#53BAFF',
                fillColor: '#003596',
                textColor: '#ffffff',
            }
        }

        window.addEventListener('tecnomap.drawer.loaded', () => {
            this.mapDrawerLoaded = true
        }, { once: true })
    },

    mounted() {
        if(window.aMaps == undefined)
        {
            window.addEventListener('tecnomap.loaded', () => {
                this.mapLoaded = true
            }, { once: true })
        }
        else
        {
            this.mapLoaded = true
        }

        this.setMapInteraction()

        // setTimeout(() => {
        //     this.setAllEstatesEnabled()
        // }, 5000)

        window.events.$on('list.update.filters', event => {
            this.mapSearch = {
                ...this.mapSearch,
                ...event
            }

            this.requestPolygons()
            this.requestEstates()
        })

        window.events.$on('list.geo', geo => {
            if (!geo) {
                this.allEstatesEnabled = false
                this.mapInteraction = true
            } else {
                // this.setAllEstatesEnabled()
                this.setMapInteraction()
            }
        })

        window.addEventListener('tecnomap.moveend', this.mapMoved)

        window.addEventListener('tecnomap.drawer.markerClick', this.showEstatePopup)
        window.addEventListener('tecnomap.drawer.markerClusterClick', this.showEstatePopup)
        window.addEventListener('tecnomap.drawer.polygons.reset', this.polygonsHaveBeenRemoved)
        window.addEventListener('tecnomap.navigationControl.geolocate.start', this.startGeolocating)
        window.addEventListener('tecnomap.navigationControl.geolocate.end', this.endGeolocating)
        window.addEventListener('tecnomap.navigationControl.geolocate.error', this.endGeolocating)
        window.addEventListener('tecnomap.navigationControl.geolocate.success', this.endGeolocating)
    },

    beforeDestroy() {
        window.removeEventListener('tecnomap.moveend', this.mapMoved)

        window.removeEventListener('tecnomap.drawer.markerClick', this.showEstatePopup)
        window.removeEventListener('tecnomap.drawer.markerClusterClick', this.showEstatePopup)
        window.removeEventListener('tecnomap.drawer.polygons.reset', this.polygonsHaveBeenRemoved)
        window.removeEventListener('tecnomap.navigationControl.geolocate.start', this.startGeolocating)
        window.removeEventListener('tecnomap.navigationControl.geolocate.end', this.endGeolocating)
        window.removeEventListener('tecnomap.navigationControl.geolocate.error', this.endGeolocating)
        window.removeEventListener('tecnomap.navigationControl.geolocate.success', this.endGeolocating)
    },

    components: {
        'tecno-map': TecnoMap
    }
}
</script>